import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconAttachmentMultiple(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 8.5c0-.924.388-1.815.99-2.477C5.6 5.353 6.347 5 7 5h10c1.14 0 1.9.232 2.35.559.4.29.65.724.65 1.441 0 .717-.25 1.15-.65 1.441C18.9 8.768 18.14 9 17 9H9c-.003-.004-.5 0-.5 0S8 9 8 8.5s.5-.5.5-.5H17V6H8c-.72 0-1.235.477-1.514.887A2.893 2.893 0 0 0 6 8.5c0 .6.185 1.17.486 1.613.28.41.795.887 1.514.887h9c1.36 0 2.6-.268 3.526-.941C21.5 9.349 22 8.283 22 7c0-1.283-.5-2.35-1.474-3.059C19.6 3.268 18.36 3 17 3H7c-1.347 0-2.6.697-3.49 1.677C2.612 5.665 2 7.024 2 8.5s.612 2.835 1.51 3.823C4.4 13.303 5.653 14 7 14h2v-2H7c-.653 0-1.4-.353-2.01-1.023C4.388 10.315 4 9.424 4 8.5Zm8 7.5h4v-4h2v4h4v2h-4v4h-2v-4h-4v-2Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
